import React from 'react';
import Icon from '../../common/Icons';
import { buildExamListSecondaryLine, getExamCoveragePillProps } from './examCatalogListDisplay';

export default function ExamCatalogListItem({
  item,
  categoryConfig,
  isAnalysis,
  selectedAnalysisFamily,
  isEditing,
  copy,
  onOpenMenu
}) {
  const secondary = buildExamListSecondaryLine(item, {
    categoryConfig,
    isAnalysis,
    selectedAnalysisFamily
  });

  const coveragePill = getExamCoveragePillProps(item.coverage_type);
  const statusLabel = item.is_active ? copy.STATUS_ACTIVE : copy.STATUS_INACTIVE;

  return (
    <li
      className={[
        'hd-exam-list__item',
        !item.is_active ? 'is-inactive' : '',
        isEditing ? 'is-editing' : ''
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span
        className={`hd-exam-list__dot${item.is_active ? ' is-active' : ' is-inactive'}`}
        title={statusLabel}
        aria-label={statusLabel}
      />
      <div className="hd-exam-list__content">
        <span className="hd-exam-list__title">{item.name}</span>
        <span className={coveragePill.className}>{coveragePill.label}</span>
        {secondary ? (
          <>
            <span className="hd-exam-list__sep" aria-hidden>
              ·
            </span>
            <span className="hd-exam-list__sub" title={secondary}>
              {secondary}
            </span>
          </>
        ) : null}
      </div>
      <button
        type="button"
        className="hd-exam-list__menu hd-exam-actions-menu__toggle"
        onClick={onOpenMenu}
        aria-label={`Actions pour ${item.name}`}
        title="Actions"
      >
        <Icon name="ellipsis-vertical" size={17} />
      </button>
    </li>
  );
}
